export const attachmentDefinitionsSelector = ({ development }) =>
  development.attachmentDefinitions.attachmentDefinitions;

export const isFetchingAttachmentDefinitionsSelector = ({ development }) =>
  development.attachmentDefinitions.isFetchingAttachmentDefinitions;

export const isUpdatingAttachmentDefinitionsSelector = ({ development }) =>
  development.attachmentDefinitions.isUpdatingAttachmentDefinitions;
